interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

function getPages(current: number, total: number): (number | string)[] {
  const pages: (number | string)[] = [];
  if (total <= 7) {
    for (let i = 1; i <= total; i += 1) pages.push(i);
    return pages;
  }
  pages.push(1);
  if (current > 3) pages.push("...");
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (current < total - 2) pages.push("...");
  pages.push(total);
  return pages;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;
  const pages = getPages(current, total);

  return (
    <nav aria-label="分页导航" className="mt-10 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={current <= 1}
        onClick={() => onChange(current - 1)}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300 px-3 text-sm text-foreground-300 transition-colors hover:border-primary-500 hover:text-primary-400 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300 disabled:hover:text-foreground-300"
      >
        <i className="ri-arrow-left-s-line text-base" aria-hidden="true"></i>
        上一页
      </button>
      {pages.map((p, idx) =>
        typeof p === "number" ? (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            aria-current={p === current ? "page" : undefined}
            className={`flex h-9 w-9 items-center justify-center rounded-md border text-sm transition-colors ${
              p === current
                ? "border-primary-500 bg-primary-500 font-700 text-background-950"
                : "border-background-300 text-foreground-300 hover:border-primary-500 hover:text-primary-400"
            }`}
          >
            {p}
          </button>
        ) : (
          <span key={`gap-${idx}`} className="flex h-9 w-9 items-center justify-center text-sm text-foreground-500">
            {p}
          </span>
        ),
      )}
      <button
        type="button"
        disabled={current >= total}
        onClick={() => onChange(current + 1)}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300 px-3 text-sm text-foreground-300 transition-colors hover:border-primary-500 hover:text-primary-400 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300 disabled:hover:text-foreground-300"
      >
        下一页
        <i className="ri-arrow-right-s-line text-base" aria-hidden="true"></i>
      </button>
    </nav>
  );
}